import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_back",
  "use": "svg_back-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"svg_back\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m1.885 7 5.529-5.529L6.47.53 0 7l6.471 6.471.943-.942L1.885 7Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol